import { AfterContentInit, Component, ElementRef, inject, Input, NgZone, OnDestroy } from '@angular/core';
import SimpleBar from 'simplebar';

type ScrollbarOptions = ConstructorParameters<typeof SimpleBar>[1];

@Component({
  selector: 'rms-scrollbar',
  template: `<ng-content />`,
  styleUrls: ['./scrollbar.component.scss'],
  host: {
    class: 'rms-scrollbar',
  },
})
export class ScrollbarComponent implements AfterContentInit, OnDestroy {
  @Input() public options?: ScrollbarOptions;
  private readonly element = inject(ElementRef);
  private readonly zone = inject(NgZone);
  public scrollbarRef?: SimpleBar;

  ngAfterContentInit(): void {
    // SimpleBar installs its own observers and scroll listeners; keeping them out of the zone avoids
    // a change detection pass per scroll frame.
    this.zone.runOutsideAngular(() => {
      this.scrollbarRef = new SimpleBar(this.element.nativeElement, this.options);
    });
  }

  ngOnDestroy(): void {
    this.scrollbarRef?.unMount();
  }
}
